export default {
  title: 'Personal information',
  modifyButtonLabel: 'Edit',
  nameLabel: 'Name',
  birthDateLabel: 'Date of birth',
  careOfLabel: 'Addressee',
  correspondence: {
    label: 'Language of correspondence',
    fr: 'French',
    en: 'English',
  },
  emails: {
    title: 'Email',
    homeEmailLabel: 'Primary: ',
    workEmailLabel: 'Secondary: ',
  },
  address: {
    addressTitle: 'Address',
    currentAddressTitle: 'Current Address',
  },
  phones: {
    title: 'Phone',
    workPhoneLabel: 'Work: ',
    homePhoneLabel: 'Home: ',
    cellPhoneLabel: 'Cell: ',
    faxPhoneLabel: 'Fax: ',
    extentionPhoneLabel: ', extension ',
  },
};
